import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  computed,
  inject,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
} from '@ionic/angular/standalone';
import { AuthenticationService } from 'src/app/core/auth/authentication.service';
import { IMAGE_SRC } from '../shared/shared-constants';
import { LoginErrorBannerComponent } from './login-error-banner/login-error-banner.component';
import { CONSTS } from './login.constants';

@Component({
  selector: 'app-login',
  imports: [
    IonButton,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardSubtitle,
    IonCardContent,
    LoginErrorBannerComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  newUserTemplate = viewChild('newUser', { read: TemplateRef });
  currentUserTemplate = viewChild('currentUser', { read: TemplateRef });

  topSection = computed(() =>
    this.hasLoginError ? this.newUserTemplate() : this.currentUserTemplate(),
  );

  bottomSection = computed(() =>
    this.hasLoginError ? this.currentUserTemplate() : this.newUserTemplate(),
  );

  private authService = inject(AuthenticationService);
  route = inject(ActivatedRoute);

  readonly CONSTS = CONSTS;
  readonly IMAGES = IMAGE_SRC;

  continue() {
    this.authService.loginInteractively();
  }

  get hasLoginError() {
    return this.route.snapshot.queryParamMap.get('userId');
  }

  get currentUserText() {
    return this.hasLoginError
      ? CONSTS.CURRENT_USER.BODY_2
      : CONSTS.CURRENT_USER.BODY;
  }
}
